<script>
export default defineComponent({
  props: {
    context: { type: Object }
  },
  setup ({ context }) {
    return () => 
      Array.from({ length: context.maxRating }, (_, i) => i + 1).map((rating) => 
        [
          h('label', {
            for: `${context.node.name}-${rating}`,
            'aria-label': `Ocena ${rating} na ${context.maxRating}`,
            class: `${context.classes.label} group/label text-rating p-[1px] cursor-pointer transition-colors duration-200 ease-in peer-checked:text-gray-300 group-hover:!text-rating peer-hover:!text-gray-300`
          }, context.slots.icon?.() || h('i', { 
            class: `${context.classes.icon} will-change-transform transition-transform duration-200 ease-in-out group-hover/label:scale-125`
          })),
          h('input', {
            id: `${context.node.name}-${rating}`,
            type: 'radio',
            name: context.node.name,
            value: rating,
            class: 'peer opacity-0 w-0 h-0',
            checked: rating == context._value,
            onChange: context.handlers.DOMInput,
            disabled: context.disabled
          })
        ]
      )
  }
})
</script>